import React from "react";

import OmniBox from "components/OmniBox";

import content from "./content";

const MapBox = props => {
  return <OmniBox {...content} className="m-auto" />;
};

export default MapBox;
